import Header from '../Header'
import Sidebar from '../Sidebar'
import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

import {
  FailureContent,
  FailureHeading,
  NoVideoImg,
  NonVideoContainer,
} from '../Home/styledComponents'
import {NonHeaderContainer} from '../TrendingRoute/styledComponents'
import {NotFoundBgContainer} from './styledComponents'

const NotFound = () => (
  <NxtWatchContext.Consumer>
    {value => {
      const {darkMode} = value
      const imgUrl = darkMode
        ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-dark-theme-img.png'
        : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-not-found-light-theme-img.png'
      return (
        <NotFoundBgContainer darkMode={darkMode}>
          <Header />
          <NonHeaderContainer darkMode={darkMode}>
            <Sidebar />
            <NonVideoContainer>
              <NoVideoImg src={imgUrl} alt="not found" />
              <FailureHeading darkMode={darkMode}>
                Page Not Found
              </FailureHeading>
              <FailureContent darkMode={darkMode}>
                we are sorry, the page you requested could not be found.
              </FailureContent>
            </NonVideoContainer>
          </NonHeaderContainer>
        </NotFoundBgContainer>
      )
    }}
  </NxtWatchContext.Consumer>
)

export default NotFound
